import React, { Component } from 'react'
import { API_GET_SERVER_SETTINGS, API_SAVE_SERVER_SETTINGS, IServerSettings } from '../api'
import { t } from '../i18n'

interface Props {
    workspaceId: string
}

interface State {
    cfg: IServerSettings
    loading: boolean
    saving: boolean
    saved: boolean
    saveFailed: boolean
}

class ServerSettings extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            cfg: { port: '', appSiteURL: '' },
            loading: true,
            saving: false,
            saved: false,
            saveFailed: false,
        }
    }

    componentDidMount() {
        API_GET_SERVER_SETTINGS(this.props.workspaceId)
            .then(r => r.ok ? r.json() : null)
            .then((data: IServerSettings | null) => {
                if (data) this.setState({ cfg: data, loading: false })
                else this.setState({ loading: false })
            })
    }

    handleChange = (field: keyof IServerSettings, value: string) => {
        this.setState(s => ({ cfg: { ...s.cfg, [field]: value }, saved: false, saveFailed: false }))
    }

    handleSave = async () => {
        this.setState({ saving: true, saved: false, saveFailed: false })
        const r = await API_SAVE_SERVER_SETTINGS(this.props.workspaceId, this.state.cfg)
        if (r.ok) {
            const data: IServerSettings = await r.json()
            this.setState({ cfg: data, saving: false, saved: true })
            // keep the "restart notice" visible; don't auto-hide
        } else {
            this.setState({ saving: false, saveFailed: true })
        }
    }

    render() {
        const { cfg, loading, saving, saved, saveFailed } = this.state
        if (loading) return <div className="p-2 text-xs text-gray-400">Loading...</div>

        const inputCls = "rounded border p-1 text-sm"
        const labelCls = "text-xs text-gray-500 mb-1"

        return (
            <div className="mt-2">
                <div className="text-xs text-gray-500 mb-3">{t('server_settings_desc')}</div>

                <div className="flex flex-col gap-3 max-w-md">
                    {/* 端口号 */}
                    <div>
                        <div className={labelCls}>{t('server_port')}</div>
                        <input
                            className={inputCls}
                            style={{ width: 100 }}
                            value={cfg.port}
                            placeholder="5010"
                            onChange={e => this.handleChange('port', e.target.value)}
                        />
                    </div>

                    {/* 访问地址 */}
                    <div>
                        <div className={labelCls}>{t('server_site_url')}</div>
                        <input
                            className={inputCls + " w-full"}
                            value={cfg.appSiteURL}
                            placeholder={t('server_site_url_hint')}
                            onChange={e => this.handleChange('appSiteURL', e.target.value)}
                        />
                        <div className="text-xs text-gray-400 mt-1">{t('server_site_url_hint')}</div>
                    </div>
                </div>

                {/* 保存按钮 */}
                <div className="flex items-center gap-2 mt-4">
                    <button
                        onClick={this.handleSave}
                        disabled={saving}
                        className="text-xs bg-blue-500 text-white rounded px-3 py-1 hover:bg-blue-600 disabled:opacity-50"
                    >
                        {saving ? '...' : t('server_save')}
                    </button>
                    {saveFailed && <span className="text-xs text-red-500">{t('server_save_fail')}</span>}
                </div>

                {/* 保存成功后显示重启提示 */}
                {saved && (
                    <div className="mt-3 p-3 bg-yellow-50 border border-yellow-300 rounded text-xs">
                        <div className="font-semibold text-yellow-800 mb-1">{t('server_save_ok')}</div>
                        <code className="bg-yellow-100 px-2 py-1 rounded text-yellow-900">./start.sh</code>
                    </div>
                )}
            </div>
        )
    }
}

export default ServerSettings
